import * as React from 'react';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import { IItemCardProps } from 'models/itemcard';
import { INodeData, IAuthContext } from 'models/common';
import * as c from 'models/constants';
import { IUserCard } from 'models/user/usercard';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { CardItemProfileInfo } from 'components';
import { FollowButton } from 'components/Common/FollowButton';
import { imgSrcAttributes } from 'helpers/common';
require('./style.css');

interface IProps extends IItemCardProps {
	item: IUserCard;
	followItem?: (itemType: string, itemId: string) => void;
	isFollowing?: boolean;
	unfollowItem?: () => void;
	t?: (key: string, options?: any) => string;
	context?: IAuthContext;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserItemCardComponent extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.followItem = this.followItem.bind(this);
	}

	public followItem(isAuthenticated, signinRedirect) {
		if (isAuthenticated()) {
			const entityIdObj: INodeData = JSON.parse(this.props.item.entityId);
			this.props.followItem(entityIdObj.type, entityIdObj.id);
		} else {
			signinRedirect();
		}
	}

	public render() {
		const { followItem, isFollowing, unfollowItem } = this.props;
		const { code, name, picture, shortDescription } = this.props.item;

		let profilePicture = picture;
		if (!profilePicture) {
			profilePicture = require('containers/Html/images/defaultUser.svg');
		}

		return (
			<div className="userItemCard">
				<Link to={`/profile/${code}`}>
					<CardItemProfileInfo name={name} description={shortDescription} />
					<div className="userPictureWrapper">
						<img className="userPicture" {...imgSrcAttributes(profilePicture)} alt="" />
					</div>
				</Link>
				<FollowButton follow={followItem} unfollow={unfollowItem} isFollowing={isFollowing} />
			</div>
		);
	}
}
const UserItemCard = withAuthContext(UserItemCardComponent);
export { UserItemCard };
